import React from 'react';
import styled from 'styled-components';

import MaternityBookletPDF from 'assets/pdfs/KindbodyMaternityBooklet.pdf';
import { OutlineButton, YellowButton } from '../../../Buttons';
import PregnancyRiskAssessmentForm from '../../../PregnancyRiskAssessmentForm';

interface Props {
  onCancelClick?: () => void;
  riskAssessmentEnabled?: boolean;
}

const ActionButtons = ({ onCancelClick }: Props) => {
  return (
    <ActionsContainer>
      <p>
        If you have not gone to your first obstetrics (OB) appointment, please take the pregnancy
        assessment.
      </p>
      <PregnancyRiskAssessmentForm
        renderTrigger={props => <BookButton {...props}>TAKE THE ASSESSMENT</BookButton>}
      />

      <BookletButton as="a" href={MaternityBookletPDF} target="_blank">
        Read your maternity booklet
      </BookletButton>

      {onCancelClick && <CancelButton onClick={onCancelClick}>Cancel tracker</CancelButton>}
    </ActionsContainer>
  );
};

export default ActionButtons;

const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  margin-top: 24px;
  padding: 0px 12px;
  flex-grow: 1;
`;

const BookButton = styled(YellowButton)`
  display: block;
  width: 100%;
  margin: 8px 0px;
`;

const BookletButton = styled(OutlineButton)`
  display: block;
  width: 100%;
`;

const CancelButton = styled.button`
  margin-top: 12px;
  background-color: transparent;
  border: none;
  font-weight: 700;
  font-size: 12px;
  text-decoration: underline;
  ${({ theme }) => theme.fonts.FoundersGrotesk};
`;
